module.exports = __webpack_public_path__ + "img/asset2.43e372a5.png";